import { createStore } from 'vuex'
import firebase from '@/firebase'

export default createStore({
  state: {
    showLoginModal: false,
    showLoading: false,
    auth: {
      isLogged: false,
      user: null,
    },
  },
  mutations: {
    logIn(state, user) {
      state.auth.isLogged = true
      state.auth.user = user
    },
    logOut(state) {
      state.auth.isLogged = false
      state.auth.user = null
    },
    async like(state, threadId) {
      firebase.functions.httpsCallable('like')({ threadId, userId: state.auth.user.uid })
    },
    async dislike(state, threadId) {
      firebase.functions.httpsCallable('dislike')({ threadId, userId: state.auth.user.uid })
    },
  },
  actions: {
  },
  modules: {
  }
})
